<template>
  <div class="featured-collection-editor">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label>標題 (Title)</label>
        <input
          type="text"
          class="form-control"
          v-model="localData.title"
          placeholder="e.g. Featured Collection"
        />
      </div>
      <div class="col-md-6 mb-3">
        <label>副標題 (Subtitle)</label>
        <input type="text" class="form-control" v-model="localData.subtitle" />
      </div>

      <ProductSelector
        v-model="localData.product_ids"
        :limit="localData.limit"
      />

      <div class="col-md-6 mb-3">
        <label>顯示數量 (Limit)</label>
        <input
          type="number"
          class="form-control"
          v-model.number="localData.limit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductSelector from "@/components/ProductSelector.vue";

export default {
  name: "FeaturedCollectionEditor",
  components: { ProductSelector },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        product_ids: [],
      }),
    },
  },
  data() {
    return {
      localData: { ...this.modelValue },
    };
  },
  computed: {},
  watch: {
    localData: {
      handler(val) {
        this.$emit("update:modelValue", val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        // Simple check to avoid loop, deep check ideal but this suffices for simple objects
        if (JSON.stringify(val) !== JSON.stringify(this.localData)) {
          // Need to be careful with array references
          this.localData = JSON.parse(JSON.stringify(val));
        }
      },
      deep: true,
    },
  },
};
</script>
